import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderReactivationResultImplEncoder } from "../../encoder/OrderReactivationResultImplEncoder";

import * as CubiqTS from "../../index";
import { OrderReactivationResult } from "../OrderReactivationResult";

export class OrderReactivationResultImpl
  extends ConcreteEncodable
  implements OrderReactivationResult
{
  public static enType: string = "com.bcdfx.service.OrderReactivationResultImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public orderState: CubiqTS.OrderState;
  /*FID=3*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderReactivationResultImplEncoder.Instance;
    this.setEncodableType(OrderReactivationResultImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderReactivationResultImpl[" +
      "orderId=" +
      this.orderId +
      "orderState=" +
      this.orderState +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
